import { apiClient } from './api'

// ── Types ──────────────────────────────────────────────────

export interface OrientationRequest {
  motif: string
  gravite: 'LEGERE' | 'MODEREE' | 'GRAVE' | 'CRITIQUE'
  besoins: string[]
  contexte?: string
  latitude: number
  longitude: number
  patientId?: string
}

export interface Recommendation {
  structureId: string
  name: string
  code: string
  totalScore: number
  rank: number
  criteriaScores: Record<string, number>
  distanceKm: number
  bedsAvailable: number | null
  freshness: string
  hasSpecialist: boolean
  hasStocks: boolean
}

export interface OrientationResult {
  orientationId: string
  orientationRef: string
  recommendations: Recommendation[]
  profileName: string
  status: string
}

export interface ConfirmRequest {
  chosenStructureId: string
}

export interface OrientationConfirmResult {
  orientationId: string
  orientationRef: string
  chosenStructureId: string
  chosenStructureName: string
  status: string
  serviceRequestId: string
}

export interface FeedbackRequest {
  feedbackType: string
  rating: number | null
  comment: string
  actualOutcome: string
}

export interface OrientationHistoryItem {
  orientationRef: string
  status: string
  motif: string
  gravite: string
  scoringProfile: string
  chosenStructureName: string | null
  createdAt: string
  recommendationsJson: string | null
}

// ── API Calls ──────────────────────────────────────────────

export const orientationAPI = {
  create: async (data: OrientationRequest): Promise<OrientationResult> => {
    const res = await apiClient.post<OrientationResult>('/api/v1/orientation', data)
    return res.data
  },

  confirm: async (orientationId: string, data: ConfirmRequest): Promise<OrientationConfirmResult> => {
    const res = await apiClient.post<OrientationConfirmResult>(
      `/api/v1/orientation/${orientationId}/confirm`,
      data
    )
    return res.data
  },

  getHistory: async (): Promise<OrientationHistoryItem[]> => {
    const res = await apiClient.get<OrientationHistoryItem[]>('/api/v1/orientation/history')
    return res.data
  },

  submitFeedback: async (orientationId: string, data: FeedbackRequest): Promise<void> => {
    await apiClient.post(`/api/v1/orientation/${orientationId}/feedback`, data)
  },

  getByRef: async (ref: string): Promise<OrientationDossier> => {
    const res = await apiClient.get<OrientationDossier>(`/api/v1/orientation/ref/${ref}`)
    return res.data
  },
}

export interface OrientationDossier {
  id: string
  tenantId: string
  orientationRef: string
  status: string
  motif: string
  gravite: string
  besoins?: string[]
  besoinsJson?: string
  latitude: number | null
  longitude: number | null
  scoringProfile: string | null
  recommendationsJson: string | null
  chosenStructureId: string | null
  chosenStructureName: string | null
  serviceRequestId: string | null
  createdAt: string
  updatedAt: string | null
}
